export default __webpack_public_path__ + "static/media/pink-circle.6420d1c6.png";